









































































































































































import { Component, Vue, Provide, Watch, Mixins } from 'vue-property-decorator';
import { Getter, namespace } from 'vuex-class';
import GlobalFnMixin from '@/util/mixins';
import { BorderCheckbox } from '@/components/Form';
import { Dropdown } from '@/components/Dropdown';
import { EmptyList } from '@/components/Empty';
import visitorConfig, { SearchTypes, SortTypes } from './config';
import R from '@/service/operation-platform/visitor';
import Drawer from './components/Drawer.vue';
import { FaceType } from '@/views/ProjectManagement/FaceLibrary/types';
import { FACE_LIBRARY_MODE_MAP } from '@/views/ProjectManagement/FaceLibrary/config';
import { timeFormat } from '@/util/filter';
import { FACE_LIBRARY_MODE_OPTIONS } from '@/views/ProjectManagement/FaceLibrary/config';
import moment from 'moment';
import { fetchPathImage } from '@/service/common';
import { md5File } from '@/util/file';

const GroupTrans = {};
FACE_LIBRARY_MODE_OPTIONS.forEach(({label, value}) => {
  GroupTrans[value] = label;
})

@Component({
    components: {
        Dropdown,
        BorderCheckbox,
        EmptyList,
        Drawer,
    },
    filters: {
      timeFormatter(val) {
        return val ? timeFormat('YYYY.MM.DD HH:mm:ss')(val) : val;
      },
      groupTrans(val) {
        return GroupTrans[val];
      },
    },
})
export default class Visitor extends Mixins(GlobalFnMixin) {
  @Getter('auth/isEnterpriseRole')
  isEnterpriseRole;

  searchTypes = visitorConfig.GEN_SEARCH_TYPES();
  readonly sortTypes = visitorConfig.GEN_SORT_TYPES();

  loading = false;
  searchType: SearchTypes = SearchTypes.ALL;
  sortType = 'ALL';
  searchInputModel = '';
  dateModel: string[] = [];
  hiddenDateModel: string[] = [];
  queryRobotModel = 'ALL';
  queryGroupModel = 'ALL';
  queryRobotOptions = [
    { label: '所有机器人', value: 'ALL'},
  ];
  queryGroupOptions = [
    { label: '所有人脸库', value: 'ALL'},
  ]
  faceLibs = [];
  operateDrawer = {
    visible: false,
    data: {
      sex: 'MALE',
    } as FaceType,
  };
  queryRobotLoading = false;
  queryGroupLoading = false;
  dataList: any[] = [];
  paginationTotal = 0;
  pageSet = {
    pageNo: 1,
    pageSize: 20,
  };
  onSearchInput = _.debounce(() => this.handleSearch(), 500);
  currentDrawerFaceType = null;
  currentDrawerFaceGroupId = null;
  currentVisitorFaceId = null;
  imgCancelTokens: any = {};
  avatars: any = {};
  blobs: any = {};
  drawerDefaultImgSet: any = {
    file: null,
  }

  @Watch('$route', {deep: true})
  handleRouteChange(n, o) {
    this.handleSearch();
  }

  @Watch('sortType')
  onSortTypeChange(n) {
    if (n === SortTypes.OTHER) {
      return;
    } else {
      this.dateModel = [];
    }
    if (n === SortTypes.ALL) {
      this.hiddenDateModel = []
    }
    const today = moment(new Date());
    const todayYMD = today.format('YYYY-MM-DD');
    if (n === SortTypes.TODAY) {
      this.hiddenDateModel = [todayYMD, todayYMD];
    }
    if (n === SortTypes.WEEK) {
      this.hiddenDateModel = [today.subtract(7, 'days').format('YYYY-MM-DD'), todayYMD];
    }
    if (n === SortTypes.MONTH) {
      this.hiddenDateModel = [today.subtract(1, 'months').format('YYYY-MM-DD'), todayYMD];
    }
    if (n === SortTypes.TREE_MONTH) {
      this.hiddenDateModel = [today.subtract(3, 'months').format('YYYY-MM-DD'), todayYMD];
    }
    this.init();
  }

  get projectId() {
    return this.$route.params.projectID;
  }

  get noData() {
    return this.dataList.length === 0;
  }

  get projectIdAsParam() {
    return this.$route.params.projectID === 'all' ? null : this.$route.params.projectID;
  }

  mounted() {
    this.fetchRobotOptions();
    this.fetchGroupOptions();
    this.init();
  }
  async init() {
    try {
      await this.pendingRequest('loading', () => Promise.all([
        this.fetchSum_pure(),
        this.fetchVisitors_pure(),
      ]))
    } catch (err) {
      this.$message.error(err.message);
    }
  }
  async execRWithAll(r: Promise<any>) {
    try {
      await this.pendingRequest('loading', () => r );
    } catch (err) {
      this.$message.error(err.message);
    }
  }
  async onCardPopoverShow(faceItem) {
    this.faceLibs = [];
    this.$set(faceItem, 'loading', true);
    this.$set(faceItem, 'popoverVisible', true);
    const params = {
      projectId: faceItem.projectId,
      deviceId: faceItem.deviceid,
    };
    try {
      this.faceLibs = await R.fetchDeviceFaceGroupOptions(params)
    } catch (err) {
      
    }
    faceItem.loading = false;
  }
  getCommonParams() {
    let sdate = this.dateModel[0];
    let edate = this.dateModel[1];
    if (this.sortType !== SortTypes.OTHER) {
      sdate = this.hiddenDateModel[0];
      edate = this.hiddenDateModel[1];
    }
    return {
      projectId: this.projectIdAsParam,
      sdate,
      edate,
      key: this.searchInputModel.length === 0 ? null : this.searchInputModel,
      groupId: this.queryGroupModel === 'ALL' ? null : this.queryGroupModel,
      deviceId: this.queryRobotModel === 'ALL' ? null : this.queryRobotModel,
    };
  }
  getSumParams() {
    return {
      ...this.getCommonParams(),
    };
  }
  getListParams() {
    return {
      ...this.pageSet,
      ...this.getCommonParams(),
      status: this.searchType === 'ALL' ? null : this.searchType,
    };
  }
  async onFaceGroupChange() {
    this.queryRobotModel = 'ALL';
    await this.fetchRobotOptions();
    this.init();
  }
  async fetchSum_pure() {
    const params  = this.getSumParams();
    const sumData = await R.fetchSum(params);
    this.searchTypes.forEach(type => {
      type.badge = sumData[type.apiKey] || 0;
    });
  }
  cancelImgRequest() {
    const cancelFns = Object.values(this.imgCancelTokens);
    while (cancelFns.length > 0) {
      cancelFns.pop()();
    }
    this.imgCancelTokens = {};
  }
  async fetchVisitors_pure() {
    const params = this.getListParams();
    this.cancelImgRequest();
    const {
      list,
      total,
    } = await R.fetchVisitors(params);
    this.dataList = list;
    this.paginationTotal = total;

    for (const item of this.dataList) {
      if (!item.imagePath) {
        continue;
      }
      if (this.avatars[item.imagePath]) {
        continue;
      }
      const {
        requestPromise,
        cancelFn,
      } = fetchPathImage(item.fromGroup ? this.getAvatar(item.imagePath) : this.getThumbAvatar(item.imagePath));
      this.imgCancelTokens[item.imagePath] = cancelFn;
      try {
        const blob = await requestPromise;
        delete this.imgCancelTokens[item.imagePath];
        this.avatars[item.imagePath] = URL.createObjectURL(blob);
        this.blobs[item.imagePath] = blob;
      } catch (err) {
      
      }
    }
  }
  async fetchGroupOptions() {
    const params = {
        projectId: this.projectIdAsParam,
    };
    this.queryGroupOptions = [
        { label: '所有人脸库', value: 'ALL'},
    ];
    this.queryGroupLoading = true;
    try {
      const list = await R.fetchFaceGroupList(params);
      if (_.isArray(list)) {
        this.queryGroupOptions.push(...list.map(i => ({
            label: i.name,
            value: i.id,
          })));
      }
    } catch (err) {
      this.$message.error(err.message);
    }
    this.queryGroupLoading = false;
  }
  async fetchRobotOptions() {
    const params = {
        projectId: this.projectIdAsParam,
        faceGroupId: this.queryGroupModel === 'ALL' ? null : this.queryGroupModel,
    };
    this.queryRobotOptions = [
        { label: '所有机器人', value: 'ALL'},
    ];
    this.queryRobotLoading = true;
    try {
      const list = await R.fetchRobotList(params);
      if (_.isArray(list)) {
        this.queryRobotOptions.push(...list.map(i => ({
            label: i.name,
            value: i.id,
          })));
      }
    } catch (err) {
      this.$message.error(err.message);
    }
    this.queryRobotLoading = false;
  }
  setSearchType(searchType: SearchTypes) {
    this.searchType = searchType;
    this.init();
  }
  setSortType(sortType) {
    this.sortType = sortType;
  }
  handleSearch() {
    this.init()
  }
  onDatePickerChange(){
    this.hiddenDateModel = [];
    this.sortType = SortTypes.OTHER;
    this.init();
  }
  onPageChange(page) {
    this.pageSet.pageNo = page;
    this.execRWithAll(this.fetchVisitors_pure());
  }
  pickLib(lib, face) {
    this.currentDrawerFaceType = lib.type;
    this.operateDrawer.visible = true;
    const blob = this.blobs[face.imagePath];
    this.drawerDefaultImgSet = {
      file: new File([blob], 'img', { lastModified: new Date().getTime(), type: blob.type }),
      face,
    };
    this.currentDrawerFaceGroupId = lib.id;
    this.currentVisitorFaceId = face.id;
    this.$nextTick(() => {
      document.dispatchEvent(new Event('click'));
    });
  }
  handleCloeOperateDrawer() {
    this.operateDrawer.visible = false;
    this.operateDrawer.data = {} as FaceType;
  }


  handleSubmitOperateDrawer() {
    this.handleCloeOperateDrawer();
    this.init();
  }

  getThumbAvatar(path) {
    return R.thumbAvatarUrl(path);
  }

  getAvatar(path) {
    return R.avatarUrl(path);
  }
}
